var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDateRegisteredIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F5A623",
    opacity: 0.1,
    y: 1.8,
    width: 16.2,
    height: 16.2,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#F5A623",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    y: 1.8,
    width: 16.2,
    height: 16.2,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7 0v3.6M4.5 0v3.6M0 7.2h16.2",
    stroke: "#F5A623",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateRegisteredIcon);
export default __webpack_public_path__ + "static/media/dateRegisteredIcon.eb501987.svg";
export { ForwardRef as ReactComponent };